import validate from "/home/likit/Apps/hobby/adsonic/node_modules/.pnpm/nuxt@3.13.2_@types+node@20.12.2_eslint@8.57.0_sass@1.72.0_typescript@5.7.3_vite@5.4.9_vue-tsc@2.2.0/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/likit/Apps/hobby/adsonic/node_modules/.pnpm/nuxt@3.13.2_@types+node@20.12.2_eslint@8.57.0_sass@1.72.0_typescript@5.7.3_vite@5.4.9_vue-tsc@2.2.0/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/middleware/auth.ts"),
  guest: () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/middleware/guest.ts"),
  "live-chat": () => import("/home/likit/Apps/hobby/adsonic/packages/nuxt/middleware/live-chat.ts")
}